import React from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/auth/AuthContext";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import StatusPelaporan from "@/pages/StatusPelaporan";
import BukuA5 from "@/pages/BukuA5";
import Mutasi from "@/pages/Mutasi";
import RekapRw from "@/pages/RekapRw";
import DetailRt from "@/pages/DetailRt";
import CetakA5 from "@/pages/CetakA5";
import MasterAset from "@/pages/MasterAset";
import { RekapBulanan, RekapTahunan, EksporData, Tentang } from "@/pages/Others";

function ProtectedRoutes() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">Memeriksa sesi admin...</div>;
  }

  if (status === "error") {
    return (
      <div className="min-h-screen grid place-items-center p-6 text-center">
        <div>
          <p className="font-semibold text-[#0e2b26]">Sesi admin tidak dapat diverifikasi.</p>
          <p className="mt-2 text-sm text-muted-foreground">Periksa koneksi lalu muat ulang halaman.</p>
          <button className="mt-4 rounded-lg bg-[#0e2b26] px-4 py-2 text-sm font-semibold text-white" onClick={() => window.location.reload()}>
            Coba lagi
          </button>
        </div>
      </div>
    );
  }

  if (status !== "authenticated") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/status" element={<StatusPelaporan />} />
        <Route path="/a5" element={<BukuA5 />} />
        <Route path="/mutasi" element={<Mutasi />} />
        <Route path="/rekap" element={<RekapRw />} />
        <Route path="/detail" element={<DetailRt />} />
        <Route path="/cetak" element={<CetakA5 />} />
        <Route path="/rekap-bulanan" element={<RekapBulanan />} />
        <Route path="/rekap-tahunan" element={<RekapTahunan />} />
        <Route path="/ekspor" element={<EksporData />} />
        <Route path="/master-aset" element={<MasterAset />} />
        <Route path="/tentang" element={<Tentang />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <>
      <Toaster richColors position="top-right" />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/*" element={<ProtectedRoutes />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </>
  );
}
